import { createActions, createReducer } from 'reduxsauce'

import QuestionamentosLicitacaoService from '../../servicos/QuestionamentosLicitacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaQuestionamentosLicitacaoInicio: [],
    buscaQuestionamentosLicitacaoSucesso: ['questionamentosLicitacao'],
    buscaQuestionamentosLicitacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaQuestionamentosLicitacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaQuestionamentosLicitacaoInicio())
        let serv = new QuestionamentosLicitacaoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaQuestionamentosLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaQuestionamentosLicitacaoErro(error)))
    }
}

const buscaQuestionamentosLicitacaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaQuestionamentosLicitacaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaQuestionamentosLicitacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.questionamentosLicitacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_QUESTIONAMENTOS_LICITACAO_INICIO]: buscaQuestionamentosLicitacaoInicio,
    [Types.BUSCA_QUESTIONAMENTOS_LICITACAO_ERRO]: buscaQuestionamentosLicitacaoErro,
    [Types.BUSCA_QUESTIONAMENTOS_LICITACAO_SUCESSO]: buscaQuestionamentosLicitacaoSucesso,
})
